<div class="modal-title text-left">{{ getTranslationWithAppName(app?.isCrm ? 'DISCONNECT_APP' : 'UNINSTALL_APP') }}</div>
<div class="modal-subtitle with-border"></div>
<div class="modal-content">
  <rosie-alert [type]="'error'" [innerHtml]="getAppSpecificTranslation('UNINSTALL_WARNING')" [customClass]="'align-items-center'"></rosie-alert>
</div>
<div class="modal-action-line with-border">
  <rosie-button (click)="close()" [customClass]="'secondary narrow'" [translationKey]="'COMMON.CANCEL'">
  </rosie-button>
  <rosie-button (click)="uninstall.emit()" [customClass]="'danger narrow slim'" [inProgress]="app?.inProgress"
    [translationKey]="app?.isCrm ? 'APP.DISCONNECT' : 'APP.UNINSTALL'">
  </rosie-button>
</div>